import { useQuery } from '@apollo/client';

import { EVENT } from '../graphql/query/eventQuery.graphql';

export const useEventQuery = (eventId: string | null) => {
  return useQuery(EVENT, {
    variables: { eventId: eventId ?? '' },
    skip: !eventId,
  });
};
